import { LinkButton } from '@cian/ui-kit';
import { IconActionMap16 } from '@cian/ui-kit-design-tokens/icons';

import { type FC } from 'react';

type ToMapListingButtonProps = {
  toMap: string;
};

export const ToMapListingButton: FC<ToMapListingButtonProps> = props => {
  const { toMap } = props;

  return (
    <LinkButton
      beforeIcon={<IconActionMap16 color="accent-main-primary" />}
      data-testid="ToMapListing"
      href={toMap}
      size="XS"
      target="_blank"
      theme="fill_white_primary"
    >
      На карте
    </LinkButton>
  );
};
